import { useEffect } from 'react';
import arrayUtilities from '../../utilities/arrayUtilities';
import stringHelpers from '../../utilities/stringHelpers'
import { RoiVertex } from './roiVertex';

export const RoiForm = ({ title, roiName, setName, points, setPoints, polygon, setPolygon, onSave, onCancel, imageSource, handleImageClick, data, ratio }) => {
   
    useEffect(() => {
        if (!arrayUtilities.isNullOrEmpty(points) && ratio) {
            setPolygon(points.reduce((acc, curr) => {
                acc += `${ curr.x * ratio },${ curr.y * ratio } `
                return acc
            }, ""))
        } else {
            setPolygon("");
        }
    }, [points, ratio])

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">{ title }</h5>
                                </div>
                            </div>
                        </div>
                        <div className="card-body bg-light border-top details-container">
                            <div className="row">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold  mt-1 mb-1">Name</p>
                                </div>
                                <div className="col-md-6 col-12">
                                    <div className="form-group mb-1">
                                        <input className="form-control mb-0" type="text" autoFocus={ true } value={ roiName } onChange={ (e) => {
                                            setName(e.target.value)
                                        } } />
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-1">Region of Interest</p>
                                </div>
                                <div className="col-md-6 col-12">
                                    <div onClick={ e => handleImageClick(e) } style={ {
                                        position: "relative"
                                    } }
                                    className='edit-image-container'
                                    >
                                        <img
                                            src={ imageSource }
                                            className='w-100'
                                        />
                                        <svg style={ {
                                            zIndex: "9999",
                                            position: "absolute",
                                            top: "0",
                                            left: "0",
                                            width: `${ document.querySelector(".edit-image-container")?.clientWidth }px`,
                                            height: `${ document.querySelector(".edit-image-container")?.clientHeight }px`
                                        } }>
                                            {ratio && polygon && <polygon className='roi-polygon' points={ polygon } />}
                                            {
                                                ratio && !arrayUtilities.isNullOrEmpty(points) &&
                                                points.map((item, index) =>
                                                    <RoiVertex
                                                        handlePointChange={ (x, y) => setPoints(prevState => prevState.toSpliced(index, 1, { x: x / ratio, y: y / ratio })) }
                                                        key={ `${ item.x }-${ item.y }` }
                                                        pointX={ item.x * ratio }
                                                        pointY={ item.y * ratio }
                                                    />
                                                )
                                            }
                                        </svg>
                                    </div>
                                    <div className='d-flex mt-2'>
                                        <button disabled={arrayUtilities.isNullOrEmpty(points)} type="button" className="btn btn-falcon-default btn-sm" onClick={ () => setPoints(prevState => prevState.toSpliced(-1, 1)) }>
                                        <i className="fas fa-undo"></i> Undo previous point</button>
                                        {data && <button disabled={stringHelpers.isNullOrEmpty(data.polygon)} type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => setPoints(stringHelpers.fetchPolygonPoints(data.polygon)) }>
                                        <i className="fas fa-undo"></i> Reset</button>}
                                        <button disabled={arrayUtilities.isNullOrEmpty(points)} type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => {
                                            setPoints([]);
                                        } }>
                                        <i className="fas fa-times"></i> Clear</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer border-top ">
                            <div className="row client-edit-buttons">
                                <div className="col-12 col-sm-auto ml-auto  pl-0">
                                    <div id="dashboard-actions">
                                        <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => onCancel() }>
                                            <i className="fas fa-times"></i> Cancel</button>
                                        <button disabled={stringHelpers.isNullOrEmpty(roiName)} type="button" className="btn btn-success btn-sm ml-2" onClick={ () => onSave() }>
                                            <i className="fas fa-check"></i> Confirm</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}